import { render, staticRenderFns } from "./OlabCartSVGGen.vue?vue&type=template&id=2c4e935e&"
import script from "./OlabCartSVGGen.vue?vue&type=script&lang=js&"
export * from "./OlabCartSVGGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports